import React from 'react';
import { useTranslation } from "react-i18next";


const NotFound = props => {
      const { t } = useTranslation(["views"]);
    return <div>
        <h1>
            {t("views:not_found.title")}
        </h1>
    </div>;
};
export default NotFound;